import { AuthT } from "../../domain/entities";

const AUTH_KEY = "_47cm272d34_1mib8yu~~!!@#E22s ./dmdjkniuyqc";

const removeAuthInCache = (): void => window.localStorage.removeItem(AUTH_KEY);

const setAuthInCache = (auth: AuthT): void =>
  window.localStorage.setItem(AUTH_KEY, JSON.stringify(auth));

/**
 *
 * @returns Retrieves the user's auth state from localStorage
 */
function getAuthFromCache(throwOnNoCache: true): AuthT;
function getAuthFromCache(throwOnNoCache?: false): AuthT | null;
// eslint-disable-next-line prefer-arrow/prefer-arrow-functions -- Can't do overloading with arrow functions
function getAuthFromCache(throwOnNoCache = false): AuthT | null {
  const serializedAuthState = localStorage.getItem(AUTH_KEY);

  if (serializedAuthState) {
    return JSON.parse(serializedAuthState) as AuthT;
  }

  if (throwOnNoCache) {
    throw new Error(
      "throwOnNoCache = true must be used after a successful user's login"
    );
  }

  return null;
}

export { removeAuthInCache, setAuthInCache, getAuthFromCache };
